import React from 'react';
import PosterImage1 from '../img/project1.png'
import PosterImage2 from '../img/project2.png'
import PosterImage3 from '../img/project3.png'
import { LuExternalLink } from "react-icons/lu";
import { FaGithub } from "react-icons/fa";
import './projects.scss'

const Projects = () => {
	const projectList = [
		{
			id: 1,
			image: PosterImage1,
			title: "Project 1",
			description:
				"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero.",
			webLink: "https://google.com",
			githubLink: "https://google.com",
		},
		{
			id: 2,
			image: PosterImage2,
			title: "Project 2",
			description:
				"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore.",
			webLink: "https://google.com",
			githubLink: "https://google.com",
		},
		{
			id: 3,
			image: PosterImage3,
			title: "Project 3",
			description:
				"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation.",
			webLink: "https://google.com",
			githubLink: "https://google.com",
		},
	];
	
	
	const openLink = (url) => {
		window.open(url, "_blank");
	};
	
	return (
		<>
			<div className="mainProjects">
				<div className="titlebar" id="projects">
					<h2>Projects</h2>
				</div>
				<div className="subProjects">
					{projectList.map((project) => (
						<div className="Projects" key={project.id}>
							<div className="InfoofProjects">
								<img src={project.image} alt={project.title} />
							</div>
							<div className="InfoofProjectsPara">
								<h3>{project.title}</h3>
								<p>{project.description}</p>
							</div>
							<div className="InfoofProjectsBtn">
								<button onClick={() => openLink(project.webLink)}>
									<LuExternalLink className="Projectlinks" />
								</button>
								<button onClick={() => openLink(project.githubLink)}>
									<FaGithub className="Projectlinks" />
								</button>
							</div>
						</div>
					))}
				</div>
			</div>
		</>
	);
};

export default Projects;